import { EVENT_GAME_TYPE_PROP_STAKE, EVENT_STATUS_OPEN } from '@ogsnetwork/opp-api-lib';
import { EVENT_GAMES_CONFIG_BRACKET_POOLS, fetchAllPropEventTickets, fetchOpenAndClosedEvents, propBetOpenEventsSelector } from '@ogsnetwork/opp-redux-lib';
import lodash from 'lodash';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector, usePrevious } from '../index';
export const GAME_TYPES = ['All', 'Props', 'Brackets'];
const REFRESH_INTERVAL_MILLISECONDS = 30000;
export function usePropBetLobby(props) {
    const dispatch = useAppDispatch();
    const authentication = useAppSelector((state) => state.authentication);
    const previousAuthenticationStatus = usePrevious(authentication.status);
    const customer = useAppSelector((state) => state.customer.customer);
    const events = useAppSelector((state) => propBetOpenEventsSelector(state));
    const ticketStatus = useAppSelector((state) => state.tickets.status);
    const { byId: eventsById, byGameType: eventsByGameType, byStatus: eventsByStatus, status: eventsStatus } = useAppSelector((state) => state.events);
    const [gameTypeChoice, setGameTypeChoice] = useState('All');
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [forcedEventsListRefresh, setForcedEventsListRefresh] = useState(true);
    const [newEventsAvailable, setNewEventsAvailable] = useState(false);
    const [refreshingEventsList, setRefreshingEventsList] = useState(false);
    const [loading, setLoading] = useState(true);
    function fetchTickets() {
        dispatch(fetchAllPropEventTickets());
    }
    function refreshEvents() {
        dispatch(fetchOpenAndClosedEvents([], 'prop_stake', props.showAppHiddenEvents ? props.showAppHiddenEvents : undefined));
    }
    function startEventsPolling() {
        setForcedEventsListRefresh(true);
        setNewEventsAvailable(false);
        setRefreshingEventsList(false);
        refreshEvents();
    }
    function updateEventsList(onlyUpdateExistingEvents = false) {
        let updateEventIds;
        let updateEvents = events;
        if (onlyUpdateExistingEvents && filteredEvents.length) {
            updateEventIds = filteredEvents.map((event) => event.id);
            updateEvents = events.filter((event) => updateEventIds.includes(event.id));
        }
        if (gameTypeChoice === 'Brackets') {
            updateEvents = updateEvents.filter((event) => event.eventGamesConfig === EVENT_GAMES_CONFIG_BRACKET_POOLS);
        }
        if (gameTypeChoice === 'Props') {
            updateEvents = updateEvents.filter((event) => event.eventGamesConfig !== EVENT_GAMES_CONFIG_BRACKET_POOLS);
        }
        setFilteredEvents(updateEvents);
        setRefreshingEventsList(false);
    }
    function handleEventsListPullDownRefresh() {
        if (newEventsAvailable) {
            setRefreshingEventsList(true);
            updateEventsList();
            setNewEventsAvailable(false);
            return;
        }
        if (refreshingEventsList) {
            return;
        }
        setRefreshingEventsList(true);
        setForcedEventsListRefresh(true);
        refreshEvents();
    }
    useEffect(() => {
        startEventsPolling();
        const refreshInterval = setInterval(refreshEvents, REFRESH_INTERVAL_MILLISECONDS);
        return () => clearInterval(refreshInterval);
    }, []);
    useEffect(() => updateEventsList, [gameTypeChoice]);
    useEffect(() => {
        if (eventsStatus === 'success') {
            const openEventIds = lodash.intersection(eventsByStatus[EVENT_STATUS_OPEN], eventsByGameType[EVENT_GAME_TYPE_PROP_STAKE]);
            const prevEventIds = events.map((event) => event.id);
            const hasNewEvents = !openEventIds.every((eventId) => prevEventIds.includes(eventId));
            const hasTransitionedEvents = !prevEventIds.every((eventId) => openEventIds.includes(eventId));
            updateEventsList(true);
            if (hasNewEvents || hasTransitionedEvents) {
                if (forcedEventsListRefresh) {
                    setForcedEventsListRefresh(false);
                    updateEventsList();
                }
                else {
                    setNewEventsAvailable(true);
                }
            }
            else if (authentication.status !== previousAuthenticationStatus) {
                updateEventsList();
            }
        }
        if (ticketStatus === 'success' || (ticketStatus === 'error' && eventsStatus === 'success')) {
            setLoading(false);
        }
        if ((authentication.status === 'loggedOut' || authentication.status === 'error') &&
            eventsStatus === 'success') {
            setLoading(false);
        }
    }, [eventsStatus, ticketStatus, authentication.status]);
    useEffect(() => {
        if (authentication.status === 'loggedIn') {
            fetchTickets();
        }
    }, [authentication.status]);
    return {
        props: {
            customer,
            events,
            eventsById,
            eventsByGameType,
            eventsByStatus,
            eventsStatus
        },
        state: {
            gameTypeChoice,
            filteredEvents,
            forcedEventsListRefresh,
            loading,
            newEventsAvailable,
            refreshingEventsList,
            setGameTypeChoice,
            setFilteredEvents,
            setForcedEventsListRefresh,
            setNewEventsAvailable,
            setRefreshingEventsList
        },
        refreshEvents,
        handleEventsListPullDownRefresh,
        startEventsPolling
    };
}
